import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const ConciergeKnowledgeSchema = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  whenToUse: z.string(),
  title: z.string(),
  knowledge: z.string(),
  enabled: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
  expiresAt: z.date().nullish(),
  isSuggestedKnowledge: z.boolean().optional(),
  suggestedKnowledgeInfo: z
    .object({ referencedConversationIds: z.array(z.string()) })
    .optional(),
  recommendedProductIds: z.array(z.string()).max(5).optional(),
  numberOfUses: z.number().int().nonnegative().default(0),
  /**
   * CRDB id, present only when read from CRDB. `_id` stays the ObjectId because
   * every write still goes to Mongo and round-trips through it.
   */
  merchantKnowledgeId: z.string().optional(),
});
export type ConciergeKnowledge = z.infer<typeof ConciergeKnowledgeSchema>;

/** How many suggestions the management list leads with, ahead of the articles. */
export const MAX_SUGGESTED_ENTRIES = 3;
